export default (status) => {
  const statusTextColors = {
    completed: 'success',
    failed: 'danger',
    processing: 'warning',
    invalid: 'danger',
    expired: 'danger',
    ['auto-success']: 'gray-500',
    ['pending']: 'primary',
    ['none-cert']: 'danger',
    ['processing-cert']: 'warning',
    ['unavailable']: 'danger',
    excluded: 'danger',
  }
  return statusTextColors[status]
}
